import { Injectable } from '@angular/core';

export const CRM_SESSION_FLAG = 'fodimi_crm_session';
export const CRM_LOGIN_PARAMS = 'fodimi_crm_login';
export const CRM_LOGIN_PATH = '/auth/crm-login';

export function captureCrmLogin(): void {
  if (window.location.pathname !== CRM_LOGIN_PATH) {
    return;
  }

  try {
    window.sessionStorage.clear();
    window.sessionStorage.setItem(CRM_SESSION_FLAG, '1');
    window.sessionStorage.setItem(CRM_LOGIN_PARAMS, window.location.hash.replace(/^#/, ''));
  } catch (e) {
  }

  window.history.replaceState(null, '', CRM_LOGIN_PATH);
}

export function takeCrmLoginParams(): URLSearchParams {
  let raw = '';

  try {
    raw = window.sessionStorage.getItem(CRM_LOGIN_PARAMS) || '';
    window.sessionStorage.removeItem(CRM_LOGIN_PARAMS);
  } catch (e) {
  }

  return new URLSearchParams(raw);
}

export function isCrmSessionTab(): boolean {
  try {
    return window.sessionStorage.getItem(CRM_SESSION_FLAG) === '1';
  } catch (e) {
    return false;
  }
}

export function appStorage(): Storage {
  return isCrmSessionTab() ? window.sessionStorage : window.localStorage;
}

export const sessionAwareStorage: Storage = {
  get length() {
    return appStorage().length;
  },
  key: (index: number) => appStorage().key(index),
  getItem: (key: string) => appStorage().getItem(key),
  setItem: (key: string, value: string) => appStorage().setItem(key, value),
  removeItem: (key: string) => appStorage().removeItem(key),
  clear: () => appStorage().clear(),
};

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  constructor() { }

  public setItem(key, value) {
    value = JSON.stringify(value);
    appStorage().setItem(key, value);
    return true;
  }

  public getItem(key) {
    const value = appStorage().getItem(key);
    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  }

  public removeItem(key: string) {
    appStorage().removeItem(key);
  }
}
